import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Grid, withStyles } from '@material-ui/core';
import PageWrapper from 'components/ui/PageWrapper';
import CustomerActions from './CustomerActions';
import PersonalInformationPreview from './PersonalInformationPreview';
import EmergencyContactPreview from './EmergencyContactPreview';
import AdditionalInfoPreview from './AdditionalInfoPreview';
import PaymentSummaryPreview from './PaymentSummaryPreview';
import UpcomingPaymentPreview from './UpcomingPaymentPreview';
import TransactionsPreview from './TransactionsPreview';
import ActivitiesPreview from './ActivitiesPreview';
import GuarantorDetails from './GuarantorDetails';

const styles = (theme) => ({
  root: {},
  actionButton: {
    marginRight: 10,
  },
});

const CustomerDetails = (props) => {
  const {
    classes,
    customerDetails,
    localisation,
    permissions,
    getPersonalInfo,
    getBalanceToSettle,
    getActivePayMethod,
    getNextPaymentAmount,
    getAllTransactions,
    getCallNotes,
    getMembershipDue,
    guarantorDetails,
    getGuarantorDetailsByAdfitNo,
    getDefaultFeeDue,
  } = props;

  const { adfitNo } = useParams();

  useEffect(() => {
    (async () => {
      await Promise.all([
        getPersonalInfo(adfitNo),
        getBalanceToSettle(adfitNo),
        getActivePayMethod(adfitNo),
        getNextPaymentAmount(adfitNo),
        getAllTransactions(adfitNo),
        getMembershipDue(adfitNo),
        getCallNotes(adfitNo),
        getGuarantorDetailsByAdfitNo(adfitNo),
        getDefaultFeeDue(adfitNo),
      ]);
    })();
  }, [
    adfitNo,
    getAllTransactions,
    getNextPaymentAmount,
    getActivePayMethod,
    getBalanceToSettle,
    getPersonalInfo,
    getCallNotes,
    getMembershipDue,
    getGuarantorDetailsByAdfitNo,
    getDefaultFeeDue,
  ]);

  return (
    <PageWrapper>
      <Grid container className={classes.root} spacing={3}>
        <Grid item xs={12}>
          <Grid item xl={9} lg={11} xs={12}>
            <CustomerActions
              localisation={localisation}
              permissions={permissions}
              adfitNo={adfitNo}
              customerDetails={customerDetails}
            />
          </Grid>
        </Grid>

        <Grid item xl={3} lg={4} xs={12}>
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              <PersonalInformationPreview
                customerDetails={customerDetails}
                localisation={localisation}
                permissions={permissions}
              />
            </Grid>

            {guarantorDetails && guarantorDetails.name && (
              <Grid item xs={12}>
                <GuarantorDetails
                  guarantorInfo={guarantorDetails}
                  localisation={localisation}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <EmergencyContactPreview
                customerDetails={customerDetails}
                localisation={localisation}
                permissions={permissions}
              />
            </Grid>
            <Grid item xs={12}>
              <AdditionalInfoPreview
                customerDetails={customerDetails}
                localisation={localisation}
                permissions={permissions}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xl={6} lg={7} xs={12}>
          <Grid container direction="row" justify="flex-start" spacing={3}>
            <Grid item xs={12}>
              <PaymentSummaryPreview
                customerDetails={customerDetails}
                localisation={localisation}
              />
            </Grid>
            <Grid item xs={12}>
              <UpcomingPaymentPreview
                customerDetails={customerDetails}
                localisation={localisation}
                permissions={permissions}
              />
            </Grid>
            <Grid item xs={12}>
              <TransactionsPreview
                customerDetails={customerDetails}
                localisation={localisation}
              />
            </Grid>
            <Grid item xs={12}>
              <ActivitiesPreview
                customerDetails={customerDetails}
                localisation={localisation}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageWrapper>
  );
};

CustomerDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  localisation: PropTypes.object,
  customerDetails: PropTypes.object,
  permissions: PropTypes.array.isRequired,
  getActivePayMethod: PropTypes.func.isRequired,
  getPersonalInfo: PropTypes.func.isRequired,
  getBalanceToSettle: PropTypes.func.isRequired,
  getNextPaymentAmount: PropTypes.func.isRequired,
  getAllTransactions: PropTypes.func.isRequired,
  getCallNotes: PropTypes.func.isRequired,
  getGuarantorDetailsByAdfitNo: PropTypes.func.isRequired,
};

export default withStyles(styles)(CustomerDetails);
